import React, { useState } from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Tooltip from "@material-ui/core/Tooltip";
import "./InfoHelper.css";

const InfoHelper = ({ text, maxWidth = 280 }) => {
  const [open, setOpen] = useState(false);
  const [pinned, setPinned] = useState(false);

  if (!text) {
    return null;
  }

  const handleClose = () => {
    setOpen(false);
    setPinned(false);
  };

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setPinned((previous) => {
      const nextPinned = !previous;
      setOpen(nextPinned);
      return nextPinned;
    });
  };

  const handleMouseEnter = () => {
    if (!pinned) {
      setOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!pinned) {
      setOpen(false);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <span className="info-helper-wrap">
        <Tooltip
          arrow
          interactive
          placement="top"
          title={text}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          classes={{
            tooltip: "info-helper-tooltip",
            arrow: "info-helper-tooltip-arrow",
          }}
          PopperProps={{
            style: { maxWidth },
            disablePortal: false,
          }}
        >
          <button
            type="button"
            className="info-helper-trigger"
            aria-label="Informação"
            aria-expanded={open}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M12 4a8 8 0 100 16 8 8 0 000-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm11.25 4.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM11 10a1 1 0 111.479.878c-.31.17-.659.413-.94.741-.286.334-.539.8-.539 1.381v1h2v-.994a.303.303 0 01.057-.085c.077-.09.208-.193.382-.288A3 3 0 109 10a1 1 0 102 0zm1.999 3.011v-.004a.02.02 0 000 .004z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </Tooltip>
      </span>
    </ClickAwayListener>
  );
};

export default InfoHelper;
